import React, { useEffect, useRef, useState } from 'react';

export function useBaseModal( isOpen: boolean, onClose: () => void, noConfirmationModal?: boolean ) {
  const modalRef = useRef<HTMLDivElement>( null );
  const [ isConfirmationOpen, setIsConfirmationOpen ] = useState( false );

  useEffect( () => {
    document.body.style.overflow = 'hidden';
  }, [] );

  useEffect( () => {
    if ( !isOpen ) {
      return;
    }
    const handleKeyDown = ( e: KeyboardEvent ) => {
      if ( e.key === 'Escape' ) {
        if ( !noConfirmationModal ) {
          setIsConfirmationOpen( true );
        } else {
          onClose();
        }
      }
    };
    window.addEventListener( 'keydown', handleKeyDown );
    return () => {
      window.removeEventListener( 'keydown', handleKeyDown );
    };
  }, [ isOpen, noConfirmationModal, onClose ] );

  const handleClose = () => {
    if ( !noConfirmationModal ) {
      setIsConfirmationOpen( true );
    } else {
      document.body.style.overflow = 'unset';
      setTimeout( () => {
        onClose();
      }, 0 );
    }
  };

  const handleOverlayClick = ( e: React.MouseEvent<HTMLDivElement> ) => {
    if ( modalRef.current && !modalRef.current.contains( e.target as Node ) ) {
      e.preventDefault();
      e.stopPropagation();
      handleClose();
    }
  };

  const handleOverlayMouseUp = ( e: React.MouseEvent<HTMLDivElement> ) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleConfirmClose = () => {
    setIsConfirmationOpen( false );
    document.body.style.overflow = 'unset';
    setTimeout( () => {
      onClose();
    }, 0 );
  };

  const handleCancelClose = () => {
    setIsConfirmationOpen( false );
  };

  return {
    isConfirmationOpen,
    handleOverlayClick,
    handleOverlayMouseUp,
    handleConfirmClose,
    handleCancelClose,
    handleClose
  };
}
